/* eslint-disable no-multi-str */
import React from "react"
import SectionContainer from "../components/SectionContainer"
import SkillViewBuilder from "./SkillViewBuilder"

import pythonLogo from "../images/pythonlogo.png"
import shellLogo from "../images/shelllogo.png"
import gitLogo from "../images/gitlogo.png"
import vimLogo from "../images/vimlogo.svg"

const skills = [
  {
    name: "Python",
    icon: pythonLogo,
    proficiency: "Proficient",
    description: "Popular general purpose programming language",
    customtext: "I use Python to write scripts in collaborative \
                projects. I've also used it academically to work \
                on Artificial Intelligence systems.",
  },
  {
    name: "Shell",
    icon: shellLogo,
    proficiency: "Familiar",
    description: "Interface for communicating with the operating system",
    customtext: "All programmers are somewhat familiar with shell \
                scripting. Most development tasks require some level \
                of interaction with the shell.",
    related: [
      {
        name: "Git",
        icon: gitLogo,
        proficiency: "Proficient"
      },
      {
        name: "Vi/Vim",
        icon: vimLogo,
        proficiency: "Familiar"
      },
    ]
  },
]

// Full section
const ScriptingSkills = () => (
  <SectionContainer header="Scripting">
    <SkillViewBuilder skills={skills} />
  </SectionContainer>
)

export default ScriptingSkills
